import PropTypes from 'prop-types';
import {
  TimeLabel,
} from 'vibeguide';
import './Gridline.scss';

function Gridline({
  height,
  label = '',
  style = {},
}) {
  return (
    <div
      className="Gridline"
      style={{
        height,
        minHeight: height,
        maxHeight: height,
      }}
    >
      <TimeLabel
        className="label"
        style={style}
        time={label}
        showTooltip
      />

      <div className="line" />
    </div>
  );
}

Gridline.propTypes = {
  height: PropTypes.number.isRequired,
  label: PropTypes.string,
  style: PropTypes.oneOfType([
    PropTypes.object,
  ]),
};

export default Gridline;
